import { Directive, HostListener, Input, Output, HostBinding, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as ProductsActions from '@app/modules/products/store/actions/products.actions';
import { selectProductsState } from '@app/modules/products/store/selectors/products.selectors';
import { first, skipWhile } from 'rxjs/operators';
import { ProductEditComponent } from '@app/modules/products/product-edit/product-edit.component';
import { MatDialog } from '@angular/material/dialog';
import * as CountsActions from '@app/modules/counts/store/actions/counts.actions';
import { selectCountsCurrentIdState } from '@app/modules/counts/store/selectors/counts.selectors';
import { SubSink } from 'subsink';
import { InventoryService } from '@app/services/inventory/inventory.service';
import { ReadComponent } from '@app/modules/products/read/read.component';

@Directive({
  selector: '[appInventoryRow]'
})
export class InventoryRowDirective implements OnDestroy{
  public subs$: SubSink = new SubSink();
  @Input() prdID;
  @Input() invitmID;
  @HostBinding('class') elementClass = 'MatRow--hover-green';
  private id;

  constructor(private store$: Store, private _matDialog: MatDialog, private _inventory: InventoryService) {
    this.subs$.add(this.store$.select(selectCountsCurrentIdState).subscribe(res => {
      this.id = res;
    }));
  }

  ngOnDestroy(){
    this.subs$.unsubscribe();
  }

  @HostListener('click', ['$event']) onClick($event){
    // if(this._inventory.isFinalizeScreen() === true){
    //   this._matDialog.open(ReadComponent, {
    //     data: {
    //       invitmID: this.invitmID
    //     },
    //     minWidth: '60vw',
    //     minHeight: '600px',
    //     maxWidth: '1000px',
    //     maxHeight: '80vh'
    //   });
    // }else{
      this._matDialog.open(ProductEditComponent, {
        data: {
          prdID: this.prdID,
          finalized: true
        },
        minWidth: '60vw',
        minHeight: '600px',
        maxWidth: '75vw',
        maxHeight: '80vh'
      });

    //}

  }


}
